import { useContext } from 'react'

import { Store, StoreContext } from '@stores'

export const useStore = (): Store => useContext({ ...StoreContext })
